import type { LocationDescriptor } from 'history';
import type { HTMLAttributes } from 'react';

export interface CardItemStudData {
  name?: string;
  breed?: string;
  champion?: string;
  image?: string;
  location?: string;
  price?: string;
  hasPedigreeBadge?: boolean;
  hasPedigreeFciBadge?: boolean;
  link?: LocationDescriptor;
  loading?: boolean;
}

export interface CardItemStudProps extends HTMLAttributes<HTMLDivElement>, CardItemStudData {}
